// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeckPlan } from './DeckPlan';
import {
    DeckPlanFromJSON,
    DeckPlanFromJSONTyped,
    DeckPlanToJSON,
    DeckPlanToJSONTyped,
} from './DeckPlan';

/**
 * An elementary component of a `Train` (for e.g. a wagon/car/locomotive or in general 'carriage') with rather permanent properties, see `TrainComponent` for its instance on a concrete journey.
 * @export
 * @interface TrainElement
 */
export interface TrainElement {
    /**
     * Aka car-UIC, which is potentially mapped to beacons installed. `/v3/vehicles/by-vehicle/{vehicleId}` may detect a `Train` composing a `TrainElement` (mainly for SBB operated `VehicleMode` TRAIN) is on its way within a certain `ServiceJourney` (null means not present).
     * @type {string}
     * @memberof TrainElement
     */
    id?: string;
    /**
     * Type of car (where a 'CAR' may be self-propelled in case of a combined passenger-car/locomotive (de:Triebwagen)): <br>x-extensible-enum:  ['FA','WR','CC','WL','CAR','LOC','UNKNOWN']
     * @type {string}
     * @memberof TrainElement
     */
    type?: string;
    /**
     * Passenger-class ('1' or '2') of the car, if known.<br>x-extensible-enum: 
     * @type {string}
     * @memberof TrainElement
     */
    passengerClass?: string;
    /**
     * 
     * @type {Set<string>}
     * @memberof TrainElement
     */
    attributes: Set<string>;
    /**
     * 
     * @type {DeckPlan}
     * @memberof TrainElement
     */
    deckPlan?: DeckPlan;
}

/**
 * Check if a given object implements the TrainElement interface.
 */
export function instanceOfTrainElement(value: object): value is TrainElement {
    if (!('attributes' in value) || value['attributes'] === undefined) return false;
    return true;
}

export function TrainElementFromJSON(json: any): TrainElement {
    return TrainElementFromJSONTyped(json, false);
}

export function TrainElementFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrainElement {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'passengerClass': json['passengerClass'] == null ? undefined : json['passengerClass'],
        'attributes': new Set(json['attributes']),
        'deckPlan': json['deckPlan'] == null ? undefined : DeckPlanFromJSON(json['deckPlan']),
    };
}

  export function TrainElementToJSON(json: any): TrainElement {
      return TrainElementToJSONTyped(json, false);
  }

  export function TrainElementToJSONTyped(value?: TrainElement | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'passengerClass': value['passengerClass'],
        'attributes': Array.from(value['attributes'] as Set<any>),
        'deckPlan': DeckPlanToJSON(value['deckPlan']),
    };
}

